import type { FlightMoneySource } from './flight_offer_source.js';

/**
 * Soma valores monetários — `undefined` para lista vazia E para moedas
 * misturadas. Um total que atravessa moedas não é um número em que alguém possa
 * agir: `800 BRL + 200 USD` não são 1.000 de nada, e rotular a soma com a moeda
 * do primeiro item mente. Não mostrar nada é a degradação honesta.
 *
 * Convive de propósito com o `sumItems` do checkout: aquele fold cai numa moeda
 * (`'BRL'`) e SEMPRE produz um total, porque o carrinho já está fechado e
 * precisa de um número pra cobrar. Este pode se calar — quem o usa tem um estado
 * "ainda não há total" pra cair.
 */
export function sumMoney(monies: readonly FlightMoneySource[]): FlightMoneySource | undefined {
  const first = monies[0];
  if (!first) return undefined;
  if (monies.some((m) => m.currency !== first.currency)) return undefined;
  const amount = monies.reduce((total, m) => total + m.amount, 0);
  return { amount, currency: first.currency };
}
